import { adminAxios } from '../helpers/api';

export const getOrderTypes = () =>
  adminAxios.get('outlet-order-types/non-catering');

export const patchOrderTypeStatus = ({ id, status }) =>
  adminAxios.patch(`outlet-order-types/${id}/set-status`, { status });
